import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cpf'
})
export class CpfPipe implements PipeTransform {
    transform(value: string | number, ...args: any[]): string {
        // converte any para string
        if (!value) {
            return '';
        }
        const result = value
            .toString()
            .replace(/[^0-9]/g, '')
            .padStart(11, '0');
        return result.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '\$1.\$2.\$3\-\$4');
    }
}
